import { BaseContainerModel } from "../base-container.model";
import { bl_wms_picking_to_packing_link_RowInterface, bl_wms_picking_to_packing_link_RowClass } from "../../dbschema/index";

export class WmsPickingToPackingLinkContainer extends BaseContainerModel {
    bl_wms_picking_to_packing_link: bl_wms_picking_to_packing_link_RowInterface = new bl_wms_picking_to_packing_link_RowClass();
}
